import React from 'react';
import SEOHead from './components/SEOHead';
import { SITE_URL } from './utils/seo';
import MainHeader from './header/MainHeader';
import Footer from './footer/Footer';
import { useTranslation } from 'react-i18next';
import './auth.css';

function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div>
      <SEOHead
        title="Politika e Privatësisë - AutoPlace"
        description="Lexo politikën e privatësisë së AutoPlace. Mësoni se si mbledhim, përdorim dhe mbrojmë të dhënat tuaja personale."
        canonical={`${SITE_URL}/privacy-policy`}
      />
      <MainHeader />

      <div className="mysearch-section">
        <div className="mysearch-content">
          <h1>{t('privacy.title')}</h1>
          <p className="text-white">{t('privacy.last_updated')}</p>
        </div>
      </div>

      <section className="section_all py-5" id="privacy-policy">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="privacy-content">
                <div className="mb-5">
                  <h2 className="font-weight-bold mb-3">
                    {t('privacy.welcome')} <span className="text-custom">AutoPlace</span>
                  </h2>
                  <p className="mb-3">{t('privacy.intro1')}</p>
                  <p className="mb-3">{t('privacy.intro2')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s1_title')}</h3>
                  <h5 className="font-weight-bold mt-4">{t('privacy.s1_1_title')}</h5>
                  <p>{t('privacy.s1_1_intro')}</p>
                  <ul>
                    <li>{t('privacy.s1_1_li1')}</li>
                    <li>{t('privacy.s1_1_li2')}</li>
                    <li>{t('privacy.s1_1_li3')}</li>
                    <li>{t('privacy.s1_1_li4')}</li>
                    <li>{t('privacy.s1_1_li5')}</li>
                    <li>{t('privacy.s1_1_li6')}</li>
                  </ul>
                  <h5 className="font-weight-bold mt-4">{t('privacy.s1_2_title')}</h5>
                  <p>{t('privacy.s1_2_intro')}</p>
                  <ul>
                    <li>{t('privacy.s1_2_li1')}</li>
                    <li>{t('privacy.s1_2_li2')}</li>
                    <li>{t('privacy.s1_2_li3')}</li>
                    <li>{t('privacy.s1_2_li4')}</li>
                    <li>{t('privacy.s1_2_li5')}</li>
                  </ul>
                  <h5 className="font-weight-bold mt-4">{t('privacy.s1_3_title')}</h5>
                  <p>{t('privacy.s1_3_intro')}</p>
                  <ul>
                    <li>{t('privacy.s1_3_li1')}</li>
                    <li>{t('privacy.s1_3_li2')}</li>
                    <li>{t('privacy.s1_3_li3')}</li>
                    <li>{t('privacy.s1_3_li4')}</li>
                    <li>{t('privacy.s1_3_li5')}</li>
                    <li>{t('privacy.s1_3_li6')}</li>
                  </ul>
                  <h5 className="font-weight-bold mt-4">{t('privacy.s1_4_title')}</h5>
                  <p>{t('privacy.s1_4_content')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s2_title')}</h3>
                  <p>{t('privacy.s2_intro')}</p>
                  <ul>
                    <li><strong>{t('privacy.s2_li1_label')}</strong> {t('privacy.s2_li1')}</li>
                    <li><strong>{t('privacy.s2_li2_label')}</strong> {t('privacy.s2_li2')}</li>
                    <li><strong>{t('privacy.s2_li3_label')}</strong> {t('privacy.s2_li3')}</li>
                    <li><strong>{t('privacy.s2_li4_label')}</strong> {t('privacy.s2_li4')}</li>
                    <li><strong>{t('privacy.s2_li5_label')}</strong> {t('privacy.s2_li5')}</li>
                    <li><strong>{t('privacy.s2_li6_label')}</strong> {t('privacy.s2_li6')}</li>
                    <li><strong>{t('privacy.s2_li7_label')}</strong> {t('privacy.s2_li7')}</li>
                    <li><strong>{t('privacy.s2_li8_label')}</strong> {t('privacy.s2_li8')}</li>
                    <li><strong>{t('privacy.s2_li9_label')}</strong> {t('privacy.s2_li9')}</li>
                  </ul>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s3_title')}</h3>
                  <h5 className="font-weight-bold mt-4">{t('privacy.s3_1_title')}</h5>
                  <p>{t('privacy.s3_1_content')}</p>
                  <h5 className="font-weight-bold mt-4">{t('privacy.s3_2_title')}</h5>
                  <p>{t('privacy.s3_2_intro')}</p>
                  <ul>
                    <li>{t('privacy.s3_2_li1')}</li>
                    <li>{t('privacy.s3_2_li2')}</li>
                    <li>{t('privacy.s3_2_li3')}</li>
                    <li>{t('privacy.s3_2_li4')}</li>
                    <li>{t('privacy.s3_2_li5')}</li>
                    <li>{t('privacy.s3_2_li6')}</li>
                  </ul>
                  <h5 className="font-weight-bold mt-4">{t('privacy.s3_3_title')}</h5>
                  <p>{t('privacy.s3_3_intro')}</p>
                  <ul>
                    <li>{t('privacy.s3_3_li1')}</li>
                    <li>{t('privacy.s3_3_li2')}</li>
                    <li>{t('privacy.s3_3_li3')}</li>
                    <li>{t('privacy.s3_3_li4')}</li>
                  </ul>
                  <h5 className="font-weight-bold mt-4">{t('privacy.s3_4_title')}</h5>
                  <p>{t('privacy.s3_4_content')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s4_title')}</h3>
                  <p>{t('privacy.s4_intro')}</p>
                  <ul>
                    <li>{t('privacy.s4_li1')}</li>
                    <li>{t('privacy.s4_li2')}</li>
                    <li>{t('privacy.s4_li3')}</li>
                    <li>{t('privacy.s4_li4')}</li>
                    <li>{t('privacy.s4_li5')}</li>
                  </ul>
                  <p className="mt-3">{t('privacy.s4_note')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s5_title')}</h3>
                  <p>{t('privacy.s5_intro')}</p>
                  <ul>
                    <li><strong>{t('privacy.s5_li1_label')}</strong> {t('privacy.s5_li1')}</li>
                    <li><strong>{t('privacy.s5_li2_label')}</strong> {t('privacy.s5_li2')}</li>
                    <li><strong>{t('privacy.s5_li3_label')}</strong> {t('privacy.s5_li3')}</li>
                    <li><strong>{t('privacy.s5_li4_label')}</strong> {t('privacy.s5_li4')}</li>
                    <li><strong>{t('privacy.s5_li5_label')}</strong> {t('privacy.s5_li5')}</li>
                    <li><strong>{t('privacy.s5_li6_label')}</strong> {t('privacy.s5_li6')}</li>
                    <li><strong>{t('privacy.s5_li7_label')}</strong> {t('privacy.s5_li7')}</li>
                  </ul>
                  <p className="mt-3">
                    {t('privacy.s5_contact')}{' '}
                    <a href="mailto:privacy@autoplace.al">privacy@autoplace.al</a>
                  </p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s6_title')}</h3>
                  <p>{t('privacy.s6_content')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s7_title')}</h3>
                  <p>{t('privacy.s7_content')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s8_title')}</h3>
                  <p>{t('privacy.s8_content')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s9_title')}</h3>
                  <p>{t('privacy.s9_content')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s10_title')}</h3>
                  <p>{t('privacy.s10_intro')}</p>
                  <ul>
                    <li><strong>{t('privacy.s10_li1_label')}</strong> {t('privacy.s10_li1')}</li>
                    <li><strong>{t('privacy.s10_li2_label')}</strong> {t('privacy.s10_li2')}</li>
                    <li><strong>{t('privacy.s10_li3_label')}</strong> {t('privacy.s10_li3')}</li>
                    <li><strong>{t('privacy.s10_li4_label')}</strong> {t('privacy.s10_li4')}</li>
                  </ul>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s11_title')}</h3>
                  <p>{t('privacy.s11_content')}</p>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s12_title')}</h3>
                  <p>{t('privacy.s12_intro')}</p>
                  <div className="mt-3">
                    <p><strong>{t('privacy.s12_team')}</strong></p>
                    <p>{t('privacy.s12_email_label')}{' '}<a href="mailto:privacy@autoplace.al">privacy@autoplace.al</a></p>
                    <p>{t('privacy.s12_support_label')}{' '}<a href="mailto:support@autoplace.al">support@autoplace.al</a></p>
                  </div>
                </div>

                <div className="mb-5">
                  <h3 className="font-weight-bold mb-3">{t('privacy.s13_title')}</h3>
                  <p>{t('privacy.s13_intro')}</p>
                  <p className="mt-2">{t('privacy.s13_email_label')}{' '}<a href="mailto:dpo@autoplace.al">dpo@autoplace.al</a></p>
                </div>

                <div className="mb-5 p-4 bg-light rounded">
                  <h4 className="font-weight-bold mb-3">{t('privacy.reg_title')}</h4>
                  <p><strong>{t('privacy.reg_gdpr_label')}</strong> {t('privacy.reg_gdpr')}</p>
                  <p className="mt-2"><strong>{t('privacy.reg_ccpa_label')}</strong> {t('privacy.reg_ccpa')}</p>
                  <p className="mt-2"><strong>{t('privacy.reg_other_label')}</strong> {t('privacy.reg_other')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
